import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { KetPageListComponent } from './page-list.component'
import { NestableModule } from '@ketshopweb/ngx-nestable'
import { KetPermissionModule } from '@ketshopweb/ui/permission'
import { NzSwitchModule } from 'ng-zorro-antd/switch'
import { FormsModule } from '@angular/forms'
import {
  NzAlertModule,
  NzButtonModule,
  NzDropDownModule,
  NzIconModule,
  NzMenuModule,
  NzModalModule,
  NzRadioModule,
  NzTabsModule,
  NzToolTipModule,
} from 'ng-zorro-antd'
import { KetAddMenuPageModule } from '../add-menu-page'
import { SortablejsModule } from 'ngx-sortablejs'
import { KetLangsModule } from '../langs'

@NgModule({
  declarations: [KetPageListComponent],
  entryComponents: [KetPageListComponent],
  imports: [
    CommonModule,
    NestableModule,
    KetPermissionModule,
    NzSwitchModule,
    FormsModule,
    NzDropDownModule,
    NzMenuModule,
    NzAlertModule,
    NzModalModule,
    NzButtonModule,
    NzIconModule,
    NzToolTipModule,
    NzTabsModule,
    KetAddMenuPageModule,
    NzRadioModule,
    SortablejsModule,
    KetLangsModule,
  ],
  exports: [KetPageListComponent],
})
export class KetPageListModule {}
